// equivalencies/EquivalencyCard.js
// Individual equivalency display card component

import React from 'react';
import { formatSmart } from './formulas.js';
import { EQUIVALENCY_METADATA } from './constants.js';
import './styles.css';

/**
 * EquivalencyCard component
 * Displays a single environmental equivalency with icon, value, unit, and description
 * 
 * @param {Object} props
 * @param {string} props.type - Type of equivalency ('gasoline', 'plasticBottles', 'aluminumCans', 'treeSeedlings')
 * @param {number} props.value - Calculated equivalency value
 * @param {number} props.rawValue - Original value for determining benefit status
 * @param {boolean} props.isBenefit - Whether this represents an environmental benefit
 */
const EquivalencyCard = ({ type, value, rawValue, isBenefit }) => {
  const metadata = EQUIVALENCY_METADATA[type];
  
  if (!metadata) {
    console.warn(`Unknown equivalency type: ${type}`);
    return null;
  }

  const formattedValue = formatSmart(value);
  const { title, unit, icon, description } = metadata;

  return (
    <div className="equivalency-card">
      <div className="equivalency-card-header">
        <span className="equivalency-icon">{icon}</span>
        <h4 className="equivalency-title">{title}</h4>
        {isBenefit && (
          <span className="benefit-badge">
            Benefit
          </span>
        )}
      </div>
      
      <div className="equivalency-value-section">
        <div className="equivalency-value">
          {formattedValue}
        </div>
        <div className="equivalency-unit">
          {unit}
        </div>
      </div>
      
      <div className="equivalency-description">
        {description}
      </div>
      
      <div className="equivalency-raw-info">
        <small>
          Based on {rawValue != null ? Math.abs(rawValue).toFixed(4) : '0.0000'} {' '}
          {metadata.category === 'energy' ? 'Million BTU' : 'MTCO₂E'}
        </small>
      </div>
    </div>
  );
};

export default EquivalencyCard;
